<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/kES8Lw/tc-custom/9781504074780.jpg?1728327070905" alt="This image is the cover for the book Handbook of Reason"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Handbook of Reason
      </h1>
      <p class="bookDescription body article font2">
        <p><b>The eminent philosopher presents a summation of his views on an encyclopedic range of topics from abstract art to Zionism.</b></p><p>Culled from years of research and introspection, the diverse observations discussed in <i>Handbook of Reason</i> by Dagobert D. Runes are bound to stimulate, challenge, and at times force upon the reader a shock of recognition grounded in universal truths.</p> In a style that moves from the aphoristic to the metaphorical, Runes offers countless gems of wisdom, often irresistibly quotable, and always profoundly moving. A humanitarian theme evolved partly from personal tragedies permeates his lifelong search for “a life of God the Spirit and the Giver/(Of) God unbound and unencumbered/By hate or prejudice/A god to love by Deeds/Not hollow hymns and vows.”
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Dagobert D. Runes
      </h2>
      
      <p class="authorDescription body article">Dagobert D. Runes was born in Zastavna, Bukovina, Austria-Hungary (now in Ukraine), and received a doctorate in philosophy from the University of Vienna&#160;in 1924. In 1926 he emigrated to the United States, where he became editor of the<I> Modern Thinker</I> and later <I>Current Digest</I>. From 1931 to 1934 he was director of the Institute for Advanced Education in New York City, and in 1941 he founded the Philosophical Library, a spiritual organization and publishing house.<BR /><BR /> Runes published an English translation of Karl Marx&rsquo;s <I>On the Jewish Question</I> under the title <I>A World Without Jews</I>, featuring an introduction that was clearly antagonistic to extreme Marxism and &ldquo;its materialism,&rdquo; yet he did not entirely negate Marxist theory. He also edited several works presenting the ideas and history of philosophy to a general audience, including his <I>Dictionary of Philosophy</I>.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2b7a1d45